'use client'

/* The reply fold in exchange blocks. A port of the artboard's capReplies()
   (Article Reader.dc.html :593-621, atelier website D09): the article body is server-rendered
   innerHTML, so the fold is applied after mount, like HeadingAnchors. A reply taller than
   1.3 x the cap is held at the cap with a fade (the CSS reads data-cap) and a button after it
   opens the rest. Re-measured whenever the document resizes (fonts and images change the
   height after mount); a reply the reader opened stays open. Data attributes, not classes,
   because class is React-managed on these nodes. The cap is fixed at 320px; the artboard's
   replyCap tweak is an editor affordance and is not ported. */

import { useEffect } from 'react'

const CAP = 320
const REPLIES = '.lgx-article main .exchange .claude'
const MORE = 'Show the rest of the reply'
const LESS = 'Show less'

export function ReplyFold() {
  useEffect(() => {
    const replies = Array.from(document.querySelectorAll<HTMLElement>(REPLIES))
    if (!replies.length) return
    const buttons = new Map<HTMLElement, HTMLButtonElement>()

    const hold = (r: HTMLElement) => {
      r.dataset.cap = '1'
      r.style.maxHeight = `${CAP}px`
    }
    const release = (r: HTMLElement) => {
      delete r.dataset.cap
      r.style.maxHeight = ''
    }

    const measure = () => {
      for (const r of replies) {
        const tall = r.scrollHeight > CAP * 1.3
        const btn = buttons.get(r)
        if (!tall) {
          release(r)
          if (btn) {
            btn.remove()
            buttons.delete(r)
          }
          continue
        }
        if (!r.dataset.opened) hold(r)
        if (!btn) {
          const b = document.createElement('button')
          b.type = 'button'
          b.className = 'more'
          b.addEventListener('click', () => {
            if (r.dataset.cap) {
              release(r)
              r.dataset.opened = '1'
              b.textContent = LESS
            } else {
              delete r.dataset.opened
              hold(r)
              b.textContent = MORE
            }
          })
          r.after(b)
          buttons.set(r, b)
        }
        buttons.get(r)!.textContent = r.dataset.opened ? LESS : MORE
      }
    }

    measure()
    const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure)
    ro?.observe(document.documentElement)
    document.fonts?.ready.then(measure)

    return () => {
      ro?.disconnect()
      buttons.forEach((b) => b.remove())
      replies.forEach((r) => {
        release(r)
        delete r.dataset.opened
      })
    }
  }, [])

  return null
}
